import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import marketingI18n from 'marketingApp/i18n';
import { map } from 'lodash-es';

import PrivateRoute from './PrivateRoute';
import NotFound from '../errors/404';
import Unauthorized from '../errors/401';
import InternalServer from '../errors/500';
import ServiceUnavailable from '../errors/503';
import Login from '@api/components/Login';
import Register from '@api/components/Register';
import ForgotPassword from '@api/components/ForgotPassword';
import ResetPassword from '@api/components/ResetPassword';
import * as routes from '@api/services/dictionaries/Routes';

import { HomePaths } from '../dictionaries/paths';
import LegacyDashRoute from './LegacyDashRoute';
import { MarketingRoutes } from '../../dashboards/Marketing/routes';
import { flatten } from 'lodash-es';
import { getRouterStore } from '@api/store';
import { useUpdateIntercom } from '../hooks/useUpdateIntercom/index';
import { I18nextProvider } from 'react-i18next';
import { ConfirmEmail } from '@api/components/ConfirmEmail';

const MarketingRoutesWithProvider = map(MarketingRoutes, (route) => ({
    ...route,
    ...{
        component: (props: any): JSX.Element => (
            <I18nextProvider i18n={marketingI18n}>
                <route.component {...props} />
            </I18nextProvider>
        ),
    },
}));

const routesWithRemotes = flatten([...Object.values(routes), ...MarketingRoutesWithProvider]);

const Router: React.FC = () => {
    const { location } = useSelector(getRouterStore);
    useUpdateIntercom();
    return (
        <Switch>
            <Route component={Login} path={HomePaths.Login} />
            <Route exact component={Register} path={HomePaths.CreateAccount} />
            <Route exact component={ConfirmEmail} path={HomePaths.ConfirmEmail} />
            <Route exact component={ForgotPassword} path={HomePaths.Forgot} />
            <Route exact component={ResetPassword} path={HomePaths.ResetPassword} />
            <Route exact component={NotFound} path={HomePaths.NotFound} />
            <Route exact component={Unauthorized} path={HomePaths.Unauthorized} />
            <Route exact component={InternalServer} path={HomePaths.InternalServerError} />
            <Route exact component={ServiceUnavailable} path={HomePaths.SERVICE_UNAVAILABLE} />
            <PrivateRoute
                exact
                accessLevel={[AccessLevel.ViewAccount]}
                component={LegacyDashRoute}
                path="/legacy"
                disableBanners={true}
                location={location}
            />
            {routesWithRemotes.map((singleRoute, index) => {
                return (
                    <PrivateRoute
                        key={`route-${index}`}
                        exact
                        path={singleRoute.path}
                        component={singleRoute.component}
                        accessLevel={singleRoute.accessLevel}
                        disableBanners={singleRoute.disableBanners}
                        location={location}
                        upsellingFeature={singleRoute.upsellingFeature}
                    />
                );
            })}

            <Redirect to={HomePaths.NotFound} />
        </Switch>
    );
};

export default connect()(Router);
